import {toUrl} from "../helpers/url";
import Axios from "axios";
import {handleAjaxSuccess} from "../helpers/SwalHelper";
import handleAjaxError from "../helpers/handleAjaxError";
import {randomNumber, randomString} from "../helpers/random";

function initRequestPushNotifications(forAdmin = true) {
	/** Methods */

	function displayPrompt() {
		// noinspection JSUnresolvedVariable
		Swal.fire({
			title: 'Do you want to receive notifications on this device?',
			icon: 'question',
			showCancelButton: true,
			confirmButtonColor: '#3085d6',
			cancelButtonColor: '#d33',
			confirmButtonText: 'Yes'
		}).then(result => {
			if (result.value) {
				requestPushNotifications();
			}
		})
	}

	function requestPushNotifications() {
		const IOS = false;

		loading();

		// noinspection JSIgnoredPromiseFromCall
		if (IOS) {
			// TODO: Setup third party notifications
			stopLoading();
			// noinspection JSUnresolvedVariable
			Swal.fire({
				icon: 'error',
				text: "Can't receive notifications on this device", // First error of the first field
			})
		} else {
			// Android or anything else
			if (!canReceivePushNotifications()) {
				stopLoading();
				// noinspection JSUnresolvedVariable
				Swal.fire({
					icon: 'error',
					text: "Can't receive notifications on this device", // First error of the first field
				})
				return;
			}

			navigator.serviceWorker.register(toUrl(`/service-worker.js`))
				.catch(handleRequestPushNotificationError);

			navigator.serviceWorker.ready
				.then(function (registration) {
					// Service worker successfully registered
					// noinspection JSUnresolvedVariable
					const subscribeOptions = {
						userVisibleOnly: true,
						applicationServerKey: urlB64ToUint8Array(window.vapid_public_key),
					};

					return registration.pushManager.subscribe(subscribeOptions);
				})
				.then(function (pushSubscription) {
					let url = forAdmin ?
						`/admin/notifications-settings/add-push-subscription` :
						`/notifications-settings/add-push-subscription`

					Axios.post(toUrl(url), {
						subscription: pushSubscription,
						deviceId: getDeviceId(),
						deviceName: getDeviceName(),
					})
						.then(handleAjaxSuccess)
						.catch(handleAjaxError)
						.finally(stopLoading);

				})
				.catch(handleRequestPushNotificationError)
		}
	}

	function handleRequestPushNotificationError(error) {
		console.log(error);
		stopLoading();
		if (
			error.message === 'User denied permission to use the Push API.' ||
			error.message === 'User denied permission to use the Push API'
		) {
			// noinspection JSUnresolvedVariable
			Swal.fire({
				icon: 'error',
				text: "User denied permission to push API",
			})
		} else {
			// noinspection JSUnresolvedVariable
			Swal.fire({
				icon: 'error',
				text: "Something went wrong, please try again later",
			})
		}
	}

	function canReceivePushNotifications() {
		if (!('serviceWorker' in navigator)) {
			// Service Worker isn't supported on this browser, disable or hide UI.
			return false;
		}

		if (!('PushManager' in window)) {
			// Push isn't supported on this browser, disable or hide UI.
			return false;
		}

		if (!storageAvailable('localStorage')) {
			return false;
		}

		return true;
	}

	function urlB64ToUint8Array(base64String) {
		const padding = '='.repeat((4 - base64String.length % 4) % 4);
		const base64 = (base64String + padding)
			.replace(/-/g, '+')
			.replace(/_/g, '/');

		const rawData = window.atob(base64);
		const outputArray = new Uint8Array(rawData.length);

		for (let i = 0; i < rawData.length; ++i) {
			outputArray[i] = rawData.charCodeAt(i);
		}
		return outputArray;
	}

	function storageAvailable(type) {
		let storage;
		try {
			storage = window[type];
			let x = '__storage_test__';
			storage.setItem(x, x);
			storage.removeItem(x);
			return true;
		} catch (e) {
			return e instanceof DOMException && (
					// everything except Firefox
					e.code === 22 ||
					// Firefox
					e.code === 1014 ||
					// test name field too, because code might not be present
					// everything except Firefox
					e.name === 'QuotaExceededError' ||
					// Firefox
					e.name === 'NS_ERROR_DOM_QUOTA_REACHED') &&
				// acknowledge QuotaExceededError only if there's something already stored
				(storage && storage.length !== 0);
		}
	}

	function getDeviceId() {
		// Check if the browser already has an id
		// or create a new one

		if (localStorage.getItem('_push_notifications_device_id')) {
			return localStorage.getItem('_push_notifications_device_id');
		} else {
			let deviceId = randomString('32') + randomNumber('4');

			localStorage.setItem('_push_notifications_device_id', deviceId);

			return deviceId;
		}
	}

	function getDeviceName() {
		let device = "Unknown";
		const ua = {
			"Linux": /Linux/i,
			"Android": /Android/i,
			"BlackBerry": /BlackBerry/i,
			"Bluebird": /EF500/i,
			"Chrome OS": /CrOS/i,
			"Datalogic": /DL-AXIS/i,
			"Honeywell": /CT50/i,
			"iPad": /iPad/i,
			"iPhone": /iPhone/i,
			"iPod": /iPod/i,
			"macOS": /Macintosh/i,
			"Windows": /IEMobile|Windows/i,
			"Zebra": /TC70|TC55/i,
		}
		Object.keys(ua).map(v => navigator.userAgent.match(ua[v]) && (device = v));
		return device;
	}

	return {
		displayPrompt,
	}
}

export {initRequestPushNotifications}
